import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
// import Sound from 'components/bolt/icons/sound';
import s from 'components/bolt/landingAudio/landingAudio.sss';
import Store from 'store/store';

// Why are we using howler just to play audio?
// (I guess it handles checking user interaction etc. - it it worth it ?)
const loadHowler = async () => {
	if (document.querySelector(`script[src*="howler.min.js"]`)) {
		return;
	}
	return new Promise((resolve, reject) => {
		let script = document.createElement('script');
		script.onload = resolve;
		script.onerror = reject;
		script.src = 'https://cdnjs.cloudflare.com/ajax/libs/howler/2.2.3/howler.min.js';
		script.type = 'module';
		document.body.appendChild(script);
	});
};

export default class LandingAudio extends Component {
	constructor(props) {
		super(props);

		this.initAudio = this.initAudio.bind(this);
		this.play = this.togglePlaying.bind(this, false);
		this.pause = this.togglePlaying.bind(this, true);
		this.togglePlaying = this.togglePlaying.bind(this);
		this.checkIfAudioShouldPlay = this.checkIfAudioShouldPlay.bind(this);
		this.onPageChange = this.onPageChange.bind(this);
		this.onVidOverlayOpen = this.onVidOverlayOpen.bind(this);
		this.onVidOverlayClose = this.onVidOverlayClose.bind(this);
		this.onEmbeddedVideoPlay = this.onEmbeddedVideoPlay.bind(this);
		this.onEmbeddedVideoPause = this.onEmbeddedVideoPause.bind(this);

		this.state = {
			userMuted: !props.data.autoplay,
			showAudio: false,
			paused: true,
		};
	}

	componentDidMount() {
		Store.on('SET_ACTIVE_PAGE', this.onPageChange);
		Store.on('OPEN_VIDEO_OVERLAY', this.onVidOverlayOpen);
		Store.on('CLOSE_VIDEO_OVERLAY', this.onVidOverlayClose);
		Store.on('EMBEDDED_VIDEO_PLAY', this.onEmbeddedVideoPlay);
		Store.on('EMBEDDED_VIDEO_PAUSE', this.onEmbeddedVideoPause);
		if (typeof window !== 'undefined') {
			this.checkIfAudioShouldPlay();
		}
	}

	componentWillUnmount() {
		Store.off('SET_ACTIVE_PAGE', this.onPageChange);
		Store.off('OPEN_VIDEO_OVERLAY', this.onVidOverlayOpen);
		Store.off('CLOSE_VIDEO_OVERLAY', this.onVidOverlayClose);
		Store.off('EMBEDDED_VIDEO_PLAY', this.onEmbeddedVideoPlay);
		Store.off('EMBEDDED_VIDEO_PAUSE', this.onEmbeddedVideoPause);

		if (this.audio) {
			this.audio.unload();
		}
	}

	async checkIfAudioShouldPlay(activePage) {
		const { userMuted } = this.state;
		activePage = activePage || this.props?.store?.activePage;

		let inclusions = this.props?.data?.inclusions || '';
		if (inclusions) {
			inclusions = inclusions.split(',').map((page) => page.trim());
		}

		if (!inclusions.length || inclusions.includes(activePage)) {
			if (!this.audio) {
				await this.initAudio();
			}
			if (this.audio && !this.audio.playing() && !userMuted) {
				this.audio.play();
			}
			this.setState({ showAudio: true });
		} else {
			this.stopAndHideAudio();
		}
	}

	onPageChange(newPage) {
		this.checkIfAudioShouldPlay(newPage);
	}

	onVidOverlayOpen() {
		this.stopAndHideAudio(true);
	}

	onVidOverlayClose() {
		this.checkIfAudioShouldPlay();
	}

	onEmbeddedVideoPlay() {
		this.stopAndHideAudio(false);
	}

	onEmbeddedVideoPause() {
		this.checkIfAudioShouldPlay();
	}

	async initAudio() {
		await loadHowler();
		const { src, loop, autoplay } = this.props.data;
		this.audio = new window.Howl({
			src: [src],
			loop,
			autoplay: autoplay && !this.state.userMuted,
			onpause: () => this.setState({ paused: true }),
			onended: () => this.setState({ paused: true }),
			onerror: () => this.setState({ paused: true }),
			onplay: () => this.setState({ paused: false }),
		});
	}

	stopAndHideAudio(restartAudio = true) {
		if (this.audio) {
			this.audio.pause();
			if (restartAudio) {
				this.audio.seek(0);
			}
		}
		this.setState({ showAudio: false });
	}

	togglePlaying(muted) {
		const { userMuted } = this.state;

		if (typeof muted !== 'boolean') {
			muted = !userMuted;
		}

		this.audio?.[muted ? 'pause' : 'play']();

		this.setState({ userMuted: muted });
	}

	render() {
		const { showAudio, userMuted } = this.state;
		const { offsetTop } = this.props;
		const { position } = this.props.data;

		if (!showAudio) {
			return;
		}

		const wrapperStyle = {};

		if (offsetTop && offsetTop > 0 && position.match(/top/)) {
			wrapperStyle.top = `${64 + offsetTop}px`;
		}

		return (
			<div
				onClick={this.togglePlaying}
				class={joinClasses(s.wrapper, userMuted && s.muted, s[position])}
				style={wrapperStyle}
			>
				<button class={s.icon} />
			</div>
		);
	}
}
